import { create } from 'zustand';

// Altitudes (world Y) used by the camera rig and cloud placement
export const ALT = { PLANE: 420, DECK_TOP: 215, DECK_BOTTOM: 150, HERO: 100, DESCENT: 260 };

export const PHASES = ['LOADING', 'AIRPLANE', 'PASSWORD', 'JUMPING', 'FREEFALL', 'CLOUD_TRANSITION', 'COIN_REVEAL', 'WEBSITE', 'PROJECT_SUBMITTED'];
export const phaseIndex = (p) => PHASES.indexOf(p);

// `frame` is mutated directly every animation frame (no React re-render)
const frame = {
  altitude: ALT.PLANE, pitch: -1.25, roll: 0, fov: 60, fog: 0, velocity: 0,
  pointer: { x: 0, y: 0 }, pointerStrength: 0,
  coin: { x: 0, y: 6, scale: 0, opacity: 0, blur: 0 },
  scroll: 0,
};

export const useExperience = create((set) => ({
  phase: 'LOADING',
  setPhase: (phase) => set({ phase }),
  quality: 'high',
  setQuality: (quality) => set({ quality }),
  webgl: true,
  setWebgl: (webgl) => set({ webgl }),
  reducedMotion: typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches,
  soundOn: false,
  setSoundOn: (soundOn) => set({ soundOn }),
  scroll: 0,
  setScroll: (scroll) => set({ scroll }),
  activeSection: 'home',
  setActiveSection: (activeSection) => set({ activeSection }),
  cloudCanvas: null,
  setCloudCanvas: (cloudCanvas) => set({ cloudCanvas }),
  frame,
}));

export const isWebsite = (phase) => phaseIndex(phase) >= phaseIndex('WEBSITE');
